import React, {Component} from 'react'
import Hammer from 'react-hammerjs'
import {throttle} from 'lodash'
import { PanStyle } from '../styles'

export default class Pan extends Component {
  state = {
    x: window.innerWidth,
    tX: 0,
    step: 200,
    enable: false
  }

  componentDidMount() {
    this.setState({ enable: this.state.x < this.elt.querySelector('ul').scrollWidth })
    window.addEventListener('resize', this.resize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  resize = throttle(() => {
    this.setState({ 
      x: window.innerWidth, 
      enable: window.innerWidth < this.elt.querySelector('ul').scrollWidth })
  }, 400)

  onPan = (event) => {
    event.stopPropagation()
    const { x, tX, step } = this.state
    const panWidth = this.elt.querySelector('ul').scrollWidth
    let n = tX
    if (x < panWidth) {
      if (event.additionalEvent === 'panleft') n = panWidth + tX <= x ? tX : n - step
      else n = tX === 0 ? 0 : n + step
      this.setState({ tX: n })
    } 
  }

  render () {
    const {children} = this.props
    const {tX, enable} = this.state
    return (
      // <Hammer onPanEnd={this.onPan}>
        <div className={`pan ${PanStyle(tX, enable)}`}>
          <div className="pan-inner" ref={ (elt) => this.elt = elt }>
            { children }
          </div>
        </div>
      // </Hammer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Pan.js